import { FileManagerTreeTable } from '@/catalog-apps/components/component-library/FileManager/FileManagerTreeTable'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { projectFileManagerActions } from './ProjectFileManagerActions'
import { useGetProjectFiles } from './useGetProjectFiles'

const ROOT_NAMESPACE = ''

export function ProjectFileManagerPageContent() {
  const { data: projectFiles } = useGetProjectFiles(ROOT_NAMESPACE)

  return (
    <TablePageContainer className="flex min-h-0 flex-col">
      <ScrollArea className="min-h-0 flex-1 pr-3">
        <FileManagerTreeTable
          files={projectFiles?.files ?? []}
          namespace={ROOT_NAMESPACE}
          actions={projectFileManagerActions}
          tableHeaderClassName="bg-muted"
          tableContainerClassName="bg-offwhite"
        />
      </ScrollArea>
    </TablePageContainer>
  )
}
